import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import * as globals from './components/GlobalScripts.js';
import './styles/GlobalStyles.css';
import Admin from './pages/Admin';
import Admin_home from './pages/admin/Admin_home';
import Admin_ventas from './pages/admin/Admin_ventas';
import Admin_ventas_view from './pages/admin/Admin_ventas_view';
import Admin_clientes from './pages/admin/Admin_clientes';
import Admin_clientes_edit from './pages/admin/Admin_clientes_edit';
import Admin_galeria from './pages/admin/Admin_galeria';
import User from './pages/User';
import User_home from './pages/user/User_home';
import User_dieta from './pages/user/User_dieta';
import User_galeria from './pages/user/User_galeria';
import User_galeria_coach from './pages/user/User_galeria_coach';
import User_contacto from './pages/user/User_contacto';
import Home from './pages/Home';
import Comprar from './pages/Comprar';
import TY from './pages/TY';
import Quest from './pages/Quest';
import Login from './pages/Login';
import Login_Code from './pages/Login_Code';
import ScrollToTop from './pages/ScrollToTop';

function App() {
  let user = JSON.parse(localStorage.getItem('user'));

  //localStorage.setItem('path_api', 'http://localhost/ecommerce/backend');
  localStorage.setItem('path_api', 'https://danithor.zadrig.com/backend');

  useEffect(() => {
    globals.closeViewCharge();
  }, []);

  return (
    <>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/admin/" element={globals.isAuthenticated() && globals.get_user()?.rol == 4 ? <Admin /> : <Navigate to="/login" replace />}>
            <Route index element={<Admin_home />}></Route>
            <Route path="/admin/ventas" element={<Admin_ventas />}></Route>
            <Route path="/admin/ventas/:id" element={<Admin_ventas_view />}></Route>
            <Route path="/admin/clientes" element={<Admin_clientes />}></Route>
            <Route path="/admin/clientes/:id" element={<Admin_clientes_edit />}></Route>
            <Route path="/admin/galeria" element={<Admin_galeria />}></Route>
          </Route>
          <Route path="/user/" element={globals.isAuthenticated()? <User /> : <Navigate to="/login" replace />}>
          <Route index element={<User_home/>}></Route>
          <Route path="/user/dieta" element={<User_dieta />}></Route>
          <Route path="/user/galeria" element={<User_galeria />}></Route>
          <Route path="/user/galeria_coach" element={<User_galeria_coach />}></Route>
          <Route path="/user/contacto" element={<User_contacto />}></Route>
          </Route>
          <Route path="/" element={<Home />}></Route>
          <Route path="/comprar" element={<Comprar />}></Route>
          <Route path="/ty" element={<TY />}></Route>
          <Route path="/quest" element={<Quest />}></Route>
          <Route path="/login" element={<Login />}></Route>
          <Route path="/login/code" element={<Login_Code />}></Route>
        </Routes>
      </Router>
    </>
  );
}

export default App;
